// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__uU8EW","widgetTitle":"styles_widgetTitle__exm7R","widgetType":"styles_widgetType__bLl+V"};